module.exports = __webpack_public_path__ + "img/sample_title.bf88abc3.png";